import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    var splide = new Splide('.read-more__slider-big', {
        gap: 24,
        pagination: false,
        arrows: true,
        autoWidth: true,
        breakpoints: {
            768: {
                arrows: false,
            }
        }
    });

    splide.mount();
});